import * as types from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    limitErrorDialog: {
        open: false,
        errorType: '',
        isGroup: false
    }
};

const setLimitErrorDialog = (state, action) => {
    return {
        ...state,
        limitErrorDialog: {
            open: action.open,
            errorType: action.errorType,
            isGroup: action.isGroup
        }
    };
};

const handlers = {
    [types.SET_SOCIAL_LIMIT_ERROR_DIALOG]: setLimitErrorDialog
};

export default function socialReducer(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];
    if (!handler) return state;
    return handler(state, action);
}

// selectors
export const selectSocialReducer = (state) => state.socialReducer;
export const selectSocialLimitErrorDialog = (state) => {
    const socialReducer = selectSocialReducer(state);
    return socialReducer.limitErrorDialog;
};
export const selectShowCommentFailedDialog = (state) => {
    const limitErrorDialog = selectSocialLimitErrorDialog(state);
    if (!limitErrorDialog) {
        return false;
    }
    return limitErrorDialog.open && limitErrorDialog.errorType === 'comment';
};
